import * as React from "react";
import { forwardRef, useCallback } from "react";
import styled from "@mui/material/styles/styled";
import { isProduction } from "fe-common/utils/envGetter";
import { ReactComponent as ViewOnAgentIcon } from "../assets/patientCard/viewOnAgentIcon.svg";
import clsx from "clsx";
import { AgentTooltip } from "fe-common/ui/AgentTooltip";
import { SortType } from "fe-common/graphql";
import { Panels } from "shared";
import { PatientCardSummaryAction } from "./patientCardCommonUi";
import { Button } from "@mui/material";

//region [[ Styles ]]
const ViewOnAgentView = styled(Button)({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  background: "#E6E4FF",
  fontWeight: "bold",
  textTransform: "capitalize",
  color: "#5A52C3",
  minWidth: "auto",
  margin: "5px",
  borderRadius: "9px",
});
//endregion [[ Styles ]]

//region [[ Props ]]
interface ViewOnAgentProps {
  className?: string;
  children?: React.ReactNode;
  caseId: string;
  label?: string;
  icon?: React.ReactNode;
  tooltip?: string;
}
//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const ViewOnAgent = forwardRef<HTMLButtonElement, ViewOnAgentProps>(
  ({ caseId, label, ...props }, ref) => {
    const onViewOnAgent = useCallback(() => {
      let url;
      if (isProduction()) {
        url = `https://diagnose.kahun.com/clinic/agent/dd?shareId=${caseId}&sort_type=${SortType.PatientProb}&dd_panel=${Panels.PatientInternalMedicine}`;
      } else {
        url = `https://develop.kahun.com/clinic/agent/dd?shareId=${caseId}&sort_type=${SortType.PatientProb}&dd_panel=${Panels.PatientInternalMedicine}`;
      }

      window.open(url, "_blank");
    }, [caseId]);

    const renderButton = useCallback(
      () => (
        <ViewOnAgentView
          ref={ref}
          className={clsx(props.className, "view-on-agent")}
          onClick={onViewOnAgent}
          startIcon={props.icon || <ViewOnAgentIcon />}
        >
          {label || "View On Agent"}
          {props.children}
        </ViewOnAgentView>
      ),
      [ref, label, props.className, props.icon, props.children, onViewOnAgent],
    );

    if (props.tooltip)
      return (
        <AgentTooltip title={props.tooltip}>{renderButton()}</AgentTooltip>
      );
    return renderButton();
  },
);
